export default __webpack_public_path__ + "static/media/vk_avatar.17c0df14.svg";